"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSaleorLinks = void 0;

var apollo_link_batch_http_1 = require("apollo-link-batch-http");

var apollo_link_retry_1 = require("apollo-link-retry");

var auth_1 = require("./auth");
/**
 * Creates list of links for Apollo client.
 * @param linksConfig Configuration for created links.
 */


exports.createSaleorLinks = function (_ref) {
  var apiUrl = _ref.apiUrl,
      tokenExpirationCallback = _ref.tokenExpirationCallback;
  var invalidTokenLink = auth_1.invalidTokenLinkWithTokenHandler(tokenExpirationCallback);
  return [invalidTokenLink, auth_1.authLink, new apollo_link_retry_1.RetryLink(), new apollo_link_batch_http_1.BatchHttpLink({
    credentials: "include",
    uri: apiUrl
  })];
};